module.exports = __webpack_public_path__ + "img/mukuai.23f9eff1.png";